import api from "shared/api";
import { ProjectRaw } from "./models";

const prefix = "api/projects";

export const getProjectsForCurrentUser = async (): Promise<ProjectRaw[]> => {
  try {
    const res = await api().get<ProjectRaw[]>(`${prefix}/current-user`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getSubscriptionsForCurrentUser = async (): Promise<
  ProjectRaw[]
> => {
  try {
    const res = await api().get<ProjectRaw[]>(
      `${prefix}/current-user/subscriptions`
    );
    return res.data;
  } catch (e) {
    throw e;
  }
};
